import axios from "axios";
import { contentConstants } from "./announcement-constant";
import { config } from "../../../../enviroment";

const announcements = (languageCode) => async (dispatch) => {
  try {
    const res = await axios({
        url: config.urls.COMMUNICATION_SERVICE_BASE_URL,
              method: "post",
              headers: { "Content-Type": "application/json",languageCode:languageCode},
              data: {
                query:
                  'query{getAnnouncementList(input:{IsPublic:"PUBLIC"}){AnnouncementId,AnnouncementTitle,AnnouncementDescription,AnnouncementType,IsPublic,ExpirationDateTime,CreateDateTime,StartDate}}'
                },
    });
    dispatch({
      type: contentConstants.ANNOUNCEMENT_SUBMIT_SUCCESS,
      payload:res.data
    
    });
  } catch (error) {
    dispatch({
      type: contentConstants.ANNOUNCEMENT_SUBMIT_FAILURE,
      payload: error.message,
    });
  }
};

const updateAnnouncementVal = (announcementId) => dispatch => {
  dispatch({
    type: contentConstants.UPDATE_SELECTED_ANNOUNCEMENT ,
    expandedAnnounceId: announcementId
  })
}

export {announcements,updateAnnouncementVal};
